import Routes from "./routes";
import { BrowserRouter as Router } from "react-router-dom";
import Header from "./components/Header";
import { useVH } from "./hooks";

const App = () => {
  useVH();

  return (
    <Router>
      <Header />
      <Routes />
    </Router>
  );
}

export default App;